import { useCareTeam } from './useCareTeam';
import { useEffect } from 'react';
import { gql } from '@apollo/client';
import { PatientContact } from '../../type';
import { graphql } from '@xolv-mybrightlink/common';

type PatientContactsResponse = {
  patients: PatientContact[];
};

export const useFetchPatientContacts = () => {
  const [store, dispatch] = useCareTeam();
  const isLoading = store === 'LOADING';
  useEffect(() => {
    const fetch = async () => {
      if (isLoading) {
        return;
      }
      const query = gql`
        query patientContacts {
          patients {
            patientGuid: guid
            contacts {
              guid
              firstName
              lastName
              relationship
              homePhone
              mobilePhone
            }
          }
        }
      `;
      const { data } = await graphql.query<PatientContactsResponse>({ query });
      dispatch({
        type: 'PATIENT_CONTACTS_UPDATE',
        patientContacts: data.patients,
      });
    };
    fetch();
  }, [isLoading, dispatch]);
};
